<div class="modal-header">
	<ng-container *ngIf="!forReUse">
		<h2 *ngIf="!isConsultDocMode" class="modal-title">
			{{ 'Documents.Form.Title' | translate }}
		</h2>

		<h2 *ngIf="isConsultDocMode" class="modal-title">
			{{ 'Documents.Form.TitleConsultation' | translate }}
		</h2>

		<button aria-label="Bouton Fermer Popin" type="button" class="modal-button-close fal fa-times" (click)="onClose()"></button>
	</ng-container>
</div>

<div class="modal-body">
	<div class="alert" *ngIf="isModalForRequiredDocs && typesPieceJointe$ | async as typesPieceJointe">
		<span
			>Vous devez télécharger un document en rapport avec la nature de votre affaire afin d'enregistrer votre saisie :
			<span class="text-bold" *ngFor="let type of typesPieceJointe; last as isLast">
				{{ type.nom }}
				<span *ngIf="isLast">.</span>
				<span *ngIf="!isLast">,</span>
			</span>
		</span>
	</div>

	<div *ngIf="!isConsultDocMode">
		<div class="section1" *ngIf="isBack || isFromFrontContactPage">
			<h3 translate="Documents.Form.Part1"></h3>
			<i *ngIf="isBack" class="fa-solid fa-scanner-image section1-column-scanner" (click)="openPopupScanDocument()"></i>
		</div>

		<upload-document
		 *ngIf="!isConsultMode"
			[files]="files"
			[viewDocumentChips]="false"
			(sendFile)="bindFilesWithForm($event)"
			[alfrescoFiles]="affaireGedDocs"
			[coordonneesBancairesFiles]="coordonneesBancairesFiles"
			[isFilesLoading]="loading"
		></upload-document>
	</div>
	<br />

	<div>
		<div *ngIf="!isConsultMode">
			<ng-container *ngIf="forReUse && !isFromPageCB; else elsePart2Bloc">
				<h3 translate="Documents.Form.Part2ForSendMail"></h3>
			</ng-container>
			<ng-template #elsePart2Bloc>
				<h3 *ngIf="!isConsultDocMode" translate="Documents.Form.Part2"></h3>
			</ng-template>
		</div>

		<!-- tableau -->
		<div class="table-responsive">
			<table class="table table-borderless letter-space" aria-describedby="listeDocuments">
				<thead>
					<tr>
						<th class="col-sortable" 
						[ngClass]="getSortClasses('name')"
						(click)="sortTable('name')">{{ 'Documents.List.Columns.Name' | translate }}</th>

						<th *ngIf="!isAddModalWithoutType" 
						class="col-sortable" 
						(click)="sortTable('type')"
						[ngClass]="getSortClasses('type')">
							{{
								isConsultDocMode
									? ('Documents.List.Columns.Type' | translate)
									: ('Documents.List.Columns.Type' | translate) + ' *'
							}}
						</th>
						<th class="col-sortable" (click)="sortTable('libelle')" [ngClass]="getSortClasses('libelle')">
							{{ 'Documents.List.Columns.Wording' | translate }}
						</th>
						<th class="col-sortable" (click)="sortTable('commentaire')" [ngClass]="getSortClasses('commentaire')">
							{{ 'Documents.List.Columns.Comment' | translate }}
						</th>
						<th class="col-sortable col-file-size" (click)="sortTable('createdAt')" [ngClass]="getSortClasses('createdAt')">
							{{ 'Documents.List.Columns.Date' | translate }}
						</th>
						<th *ngIf="pageAffaireId"  class="col-sortable col-file-size" (click)="sortTable('relatedTo')" [ngClass]="getSortClasses('relatedTo')">
							{{ 'Documents.List.Columns.RelatedTo' | translate }}
						</th>
						<th class="col-sortable col-file-size" (click)="sortTable('size')"  [ngClass]="getSortClasses('size')">
							{{ 'Documents.List.Columns.Weight' | translate }}
						</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<ng-container [formGroup]="formTemps">
						<!-- TODO: changer ce foreach sur la <tr> par un composent elementaire -->
						<tr *ngFor="let item of gedDocs; let i = index" class="table-row">
							<td>
								<a *ngIf="!isFront; else downloadLink" (click)="getUrlFile(item)" href="javascript:void(0)">
									{{ item.name }}
								</a>

								<!-- Côté FO : téléchargement direct -->
								<ng-template #downloadLink>
									<a (click)="DownloadDocument(item)" href="javascript:void(0)">
										{{ item.name }}
									</a>
								</ng-template>
							</td>
							<td *ngIf="!isAddModalWithoutType">{{ item.typePieceJointe }}</td>
							<td>
								{{ item.libelle === 'null' ? '' : item.libelle }}
							</td>
							<td>
								{{ item.commentaire === 'null' ? '' : item.commentaire }}
							</td>
							<td>{{ item.createdAt != null ? (item.createdAt | date: 'dd/MM/yyyy HH:mm:ss') : '-' }}</td>
							<td *ngIf="pageAffaireId" >
								{{ getAttacheA(item) }}
							</td>
							<td>{{ formatBytes(item.size) }}</td>
							<td>
								<div class="button-ged">
									<button aria-label="Bouton Ged"
											*ngIf="!isFront"
											type="button"
											(click)="getUrlFile(item)"
											class="btn btn-secondary btn-sm">
										<i class="far fa-eye"></i>
									</button>
									<button aria-label="Bouton Telecharger Ged"
											*ngIf="isFront"
											type="button"
											(click)="DownloadDocument(item)"
											class="btn btn-secondary btn-sm">
										<i class="fas fa-file-download"></i>
									</button>
									<div [matTooltip]="deleteTooltip(item)" style="margin-right: 5px">
										
										<button
											*ngIf="!isConsultMode"
											aria-label="Bouton Supprimer Fichier"
											type="button"
											(click)="onRemoveFile(i, item.id)"
											[disabled]="!canDeleteFile(item)"
											class="btn btn-secondary btn-sm btn-trash"
										>
											<i class="fas fa-trash"></i>
										</button>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<loader-spinner *ngIf="isLoadingFiles"></loader-spinner>
						</tr>
						<!-- Liste des fichiers qui sont attachés aux coordonnées bancaires -->
						<tr *ngFor="let item of coordonneesBancairesFiles; let i = index" class="table-row">
							<td>{{ item?.file?.name }}</td>
							<td>{{ getNomTypePieceJointe(item.typePieceJointeId) }}</td>
							<td>{{ item?.libelle }}</td>
							<td>{{ item?.commentaire }}</td>
							<td>{{ item.createdAt != null ? (item.createdAt | date: 'd/M/yy H:mm:ss' ) : '-' }}</td>
							<td *ngIf="pageAffaireId" >
								{{ getAttacheA(item) }}
							</td>
							<td>{{ formatBytes(item?.file?.size) }}</td>
							<td *ngIf="isFromPageCB">
								<div>
									<button
										aria-label="Bouton Supprimer Document"
										*ngIf="!isConsultMode"
										type="button"
										(click)="removeFile(i, item?.file?.name, $event)"
										class="btn btn-secondary btn-sm btn-trash"
									>
										<i class="fas fa-trash"></i>
									</button>
								</div>
							</td>
						</tr>

						<!-- TODO: changer ce foreach sur la <tr> par un composent elementaire -->
						<tr *ngFor="let item of filesListTemps?.controls; let i = index" class="table-row-form" formArrayName="filesList">
							<td>{{ item.get('file')?.value?.name }}</td>
							<!-- Display the file name -->
							<td *ngIf="!isAddModalWithoutType && typesPieceJointe$ | async as typesPieceJointe">
								 <ng-select
									style="width: 150px"
									labelForId="{{ 'typePieceJointeId' + i }}"
									id="{{ 'typePieceJointeId' + i }}"
									[formControl]="item.get('typePieceJointeId')"
									appendTo="body"
									[searchable]="true"
									[placeholder]="'Forms.Placeholder.Select' | translate"
									[notFoundText]="'NgSelect.NotFoundText' | translate"
									[typeToSearchText]="'NgSelect.TypeToSearchText' | translate"
									[loadingText]="'NgSelect.LoadingText' | translate"
									[clearAllText]="'NgSelect.ClearAllText' | translate"
									[clearable]="false"
								>
									<ng-option *ngFor="let type of typesPieceJointe" [value]="type.id">
										{{ type.nom }}
									</ng-option>
								</ng-select>
								<form-control-feedback [field]="item.get('typePieceJointeId')"></form-control-feedback>
							</td>

							<td>
								<input
									[formControl]="item.get('libelle')"
									id="{{ 'libelle' + i }}"
									type="text"
									class="form-control mb-4"
									placeholder="Libellé"
									maxLength="50"
								/>
								{{ 50 - item.get('libelle')?.value?.length }} {{ 'CoordonnesBancairesForm.CaracteresRestants' | translate }}
							</td>
							<td>
								<textarea
									[placeholder]="'Forms.Placeholder.Comment' | translate"
									class="form-control commentaire"
									id="{{ 'commentaire' + i }}"
									[formControl]="item.get('commentaire')"
									rows="2"
									maxLength="150"
								>
								</textarea>
								{{ 150 - item.get('commentaire')?.value?.length }} {{ 'CoordonnesBancairesForm.CaracteresRestants' | translate }}
							</td>
							<td>-</td> <!-- Date creation -->
							<td *ngIf="pageAffaireId" ></td>
							<td>{{ formatBytes(item.get('file')?.value?.size) }}</td>							
							<!-- Display the file size -->
							<td>
								<div class="button-ged">
									<button
										aria-label="Bouton Telecharger Ged"
										*ngIf="courrierFile != null"
										type="button"
										(click)="onDownload(item.get('file')?.value, item.get('file')?.value?.name)"
										class="btn btn-secondary btn-sm"
									>
										<i class="fas fa-file-download"></i>
									</button>
									<button										
										aria-label="Bouton Supprimer Document"
										type="button"
										(click)="removeFile(i, item.get('file')?.value?.name)"
										class="btn btn-secondary btn-sm btn-trash"
									>
										<i class="fas fa-trash"></i>
									</button>
								</div>
							</td>
						</tr>

						<tr
							*ngIf="filesListTemps?.controls?.length < 1 && gedDocs?.length < 1 && coordonneesBancairesFiles?.length < 1 && coordonneesBancairesFilesFromAlfresco?.length < 1"
							datagrid-row-empty
							translationKey="Documents.List.Columns.NoResultFound"
							[colspan]="9"
						></tr>
					</ng-container>
				</tbody>
			</table>
			<p *ngIf="!isConsultDocMode && !isAddModalWithoutType" class="form-required-fields" translate="Forms.RequiredFields"></p>
			<div class="paginator" *ngIf="gedDocs?.length > 0">
				<button type="button" class="paginator-btn btn-sm" (click)="changePage(currentPage - 1)" [disabled]="skipCount === 0">
					<i class="fas fa-angle-left"></i>
				</button>

				<span>{{ 'Pagination.PageNumberLabel' | translate }} {{ currentPage }} </span>

				<button type="button" class="paginator-btn btn-sm" (click)="changePage(currentPage + 1)" [disabled]="hasMoreItems === false">
					<i class="fas fa-angle-right"></i>
				</button>
				<ng-select
					class="paginator-select"
					appendTo="body"
					[clearable]="false"
					(change)="changePageSize($event)"
					[ngModel]="currentPageSize"
				>
					<ng-option *ngFor="let size of pageSizes" [value]="size"> {{ size }} </ng-option>
				</ng-select>
			</div>
		</div>
	</div>
	<p #uploadDocFooterPageAnchor></p>
</div>

<div *ngIf="!forReUse" class="modal-footer">
	<button aria-label="Bouton Fermer Popin" type="button" class="btn btn-secondary" (click)="onClose()">
		<i class="far fa-times"></i>
		{{ 'Actions.Cancel' | translate }}
	</button>

	<button
		id="save-documents"
		aria-label="Bouton Enregistrer Documents"
		*ngIf="!isConsultDocMode"
		type="button"
		class="btn btn-primary"
		(click)="onConfirm()"
		[disabled]="loading"
	>
		<i class="far fa-check"></i>
		{{ 'Actions.Save' | translate }}
		<loader-button-spinner [isShowButtonSpinner]="loading"></loader-button-spinner>
	</button>
</div>
